import api from './api.js';

class Favorites {
    constructor(){
        this.lookup_url = 'Users/Favorites';
    }

    getFavorites() {
        return api.get(this.lookup_url);
    }

    isFavorite(orderId) {
        return api.get(`${this.lookup_url}/IsFavorite/${orderId}`, { isDataSourceRequest: true });
    }

    setFavorite(orderId) {
        return api.post(`${this.lookup_url}`, { orderId });
    }

    removeFavorite(orderId) {
        return api.delete(`${this.lookup_url}/${orderId}`);
    }
}

export default new Favorites;
